import { faSleigh } from '@fortawesome/free-solid-svg-icons';
import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
import { IconType } from '../../../components/atoms/icon/icon';
// import tableVodCatalog from './tableVodTemplateCatalog';
import MapConfigFields from './formGroup10MapConfigurationFields';


export default {
  title: 'Map configuration',
  attributeName: 'mapConfig',
  fields: [
    // {
    //   attributeName: 'importSettings',
    //   helpText: 'Select a valid Image settings to be imported on this popup',
    //   type: FormInputTypes.SELECT,
    //   label: 'Import Image Settings',
    //   placeholder: 'Please enter a valid image setting',
    //   multiple: false,
    //   url: 'liveSettingsList',
    //   validateUrl:'liveSettingsValidate/liveId',
    //   emptyValue:true,
    //   default:'(Empty)', //default value to empty option
    //   fieldValue:'id',
    //   fieldName:'name',
    //   asyncSelect: true,
    //   options:[],
    //   sessionParams: ['liveId'],

    // },
    {
      attributeName: 'importButton',
      label: 'Create Live from template',
      type: FormInputTypes.BUTTON_POPUP,
      icon: IconType.NEW,
      buttonText:"Import Images from Settings",
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Create new Live from this template.',
      // redirectUrl:'lives',
      actionUrl:'liveSettingsSelected',
      isEditId:true,
      formConfig:
        {
          title: 'Import Images from Live Settings',
          description:'You can get the hole set of images from Settings to fill all images in a row',
          attributeName: 'newImageSettings',
          fields: [
            {
              attributeName: 'importSettings',
              helpText: 'Select a valid Image settings to be imported on this popup',
              type: FormInputTypes.SELECT,
              label: 'Import Image Settings From',
              placeholder: 'Please enter a valid image setting',
              multiple: false,
              url: 'liveSettingsList',
              validateUrl:'liveSettingsValidate/liveId',
              emptyValue:true,
              default:'(Empty)', //default value to empty option
              fieldValue:'id',
              fieldName:'name',
              asyncSelect: true,
              options:[],
              sessionParams: ['liveId'],

            },
          ]
        }
    },   
    {
      attributeName: 'mapConfig',
      type: FormInputTypes.JSON_COMPONENT,
      canCreate:false,
      canRemove:false,
      emptyMessage: "You don't have any map config, click on the +new button to make a new one.",
      columns:1,
      items:1,
      label: 'Map configuration',
      itemLabel:'Map config',
      required: true,
      helpText: 'Insert new map config.',
      errorText: '',
      extraValues:['deploymentType'],
      popupFormGroups:[
        MapConfigFields,
      ]
    },
  ]
};